import React from "react";
import { Spinner } from "react-bootstrap";

// import ReactLogo from '../assets/images/mini-logo.png';

const Preloader = (props) => {
  const { isFullHeight } = props;

  return (
    <div
      className={`preloader d-flex w-100 left-0 top-0 justify-content-center align-items-center ${
        isFullHeight ? "vh-100" : "h-100"
      }`}
    >
      <Spinner animation="border" variant="primary" />
    </div>
  );
};

export default Preloader;
